// Real product films from the live Shopify store (muted loops, hover/scroll play)
window.LX_VIDEOS = {
  "whisper-gaia-inspired-by-louis-vuitton-ombre-nomade": {
    sd: "https://cdn.shopify.com/videos/c/vp/becf232787224d9ba5e5de922e24f674/becf232787224d9ba5e5de922e24f674.HD-720p-1.6Mbps-92904462.mp4",
    hd: "https://cdn.shopify.com/videos/c/vp/becf232787224d9ba5e5de922e24f674/becf232787224d9ba5e5de922e24f674.HD-1080p-2.5Mbps-92904462.mp4"
  },
  "royal-legend-inspired-by-creed-aventus": {
    sd: "https://cdn.shopify.com/videos/c/vp/b6ec62c18e814d128feb20ddfaac0414/b6ec62c18e814d128feb20ddfaac0414.HD-720p-4.5Mbps-86889077.mp4",
    hd: "https://cdn.shopify.com/videos/c/vp/b6ec62c18e814d128feb20ddfaac0414/b6ec62c18e814d128feb20ddfaac0414.HD-1080p-7.2Mbps-86889077.mp4"
  },
  "oud-royale-inspired-by-tom-ford-oud-wood": {
    sd: "https://cdn.shopify.com/videos/c/vp/f7efd129b4984347a71c376165fd4bb4/f7efd129b4984347a71c376165fd4bb4.HD-720p-4.5Mbps-86793792.mp4",
    hd: "https://cdn.shopify.com/videos/c/vp/f7efd129b4984347a71c376165fd4bb4/f7efd129b4984347a71c376165fd4bb4.HD-1080p-7.2Mbps-86793792.mp4"
  },
  "ruby-embrace-inspired-by-tom-ford-s-lost-cherry": {
    sd: "https://cdn.shopify.com/videos/c/vp/e4e35103db044f1f83af7f9371eb5c5b/e4e35103db044f1f83af7f9371eb5c5b.HD-720p-4.5Mbps-86888207.mp4",
    hd: "https://cdn.shopify.com/videos/c/vp/e4e35103db044f1f83af7f9371eb5c5b/e4e35103db044f1f83af7f9371eb5c5b.HD-1080p-7.2Mbps-86888207.mp4"
  },
  "velvet-spice-tobacco-vanille-inspired": {
    sd: "https://cdn.shopify.com/videos/c/vp/40b0325dec244b919e51e9482d013192/40b0325dec244b919e51e9482d013192.HD-720p-4.5Mbps-86888574.mp4",
    hd: "https://cdn.shopify.com/videos/c/vp/40b0325dec244b919e51e9482d013192/40b0325dec244b919e51e9482d013192.HD-1080p-7.2Mbps-86888574.mp4"
  },
  "royal-whisper-inspired-by-baccarat-rouge-540": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-royal-whisper.mp4?v=1784032398",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-royal-whisper.mp4?v=1784032398"
  },
  "wild-legend-inspired-by-dior-sauvage": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-wild-legend.mp4?v=1784032398",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-wild-legend.mp4?v=1784032398"
  },
  "noir-santal-inspired-by-santal-33": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-noir-santal.mp4?v=1784032398",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-noir-santal.mp4?v=1784032398"
  },
  "velvet-nectar-bitter-peach-inspired": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-velvet-nectar.mp4?v=1784032398",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-velvet-nectar.mp4?v=1784032398"
  },
  "pure-blossom-flowerbomb-inspired-perfume": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-pure-blossom.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-pure-blossom.mp4?v=1784035834"
  },
  "after-dark": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-after-dark-b.mp4?v=1784198940",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-after-dark-b.mp4?v=1784198940"
  },
  "blush-desire-inspired-by-love-dont-be-shy": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-blush-desire.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-blush-desire.mp4?v=1784035834"
  },
  "midnight-silk": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-midnight-silk-b.mp4?v=1784046938",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-midnight-silk-b.mp4?v=1784046938"
  },
  "azure-breeze-inspired-by-dolce-gabbana-light-blue": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-azure-breeze-v2.mp4?v=1784573194",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-azure-breeze-v2.mp4?v=1784573194"
  },
  "free-spirit-inspired-by-ysl-libre": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-free-spirit.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-free-spirit.mp4?v=1784035834"
  },
  "garden-aura-inspired-by-gucci-bloom": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-garden-aura-b.mp4?v=1784046937",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-garden-aura-b.mp4?v=1784046937"
  },
  "amber-essence-inspired-by-chanel-coco-mademoiselle": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-amber-essence.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-amber-essence.mp4?v=1784035834"
  },
  "radiant-aura": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-radiant-aura.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-radiant-aura.mp4?v=1784035834"
  },
  "sapphire-essence-inspired-by-bleu-de-chanel": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-sapphire-essence.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-sapphire-essence.mp4?v=1784035834"
  },
  "golden-meadow-inspired-by-marc-jacobs-daisy": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-golden-meadow.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-golden-meadow.mp4?v=1784035834"
  },
  "enigma-essence-inspired-by-mugler-alien": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-enigma-essence.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-enigma-essence.mp4?v=1784035834"
  },
  "nightfall-essence": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-nightfall-essence.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-nightfall-essence.mp4?v=1784035834"
  },
  "velvet-rose-eau-de-parfum": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-velvet-rose-b.mp4?v=1784046937",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-velvet-rose-b.mp4?v=1784046937"
  },
  "aquatic-icon-inspired-by-armani-acqua-di-gio": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-aquatic-icon.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-aquatic-icon.mp4?v=1784035834"
  },
  "signature-blanc-perfume-inspired-by-chanel-no-5": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-signature-blanc-b.mp4?v=1784046937",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-signature-blanc-b.mp4?v=1784046937"
  },
  "mythic-legend": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-mythic-legend-b.mp4?v=1784046938",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-mythic-legend-b.mp4?v=1784046938"
  },
  "amber-hearth-inspired-by-maison-margiela-by-the-fireplace": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-amber-hearth.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-amber-hearth.mp4?v=1784035834"
  },
  "platinum-silk-byredo-gypsy-water-inspired": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-platinum-silk.mp4?v=1784035835",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-platinum-silk.mp4?v=1784035835"
  },
  "snowtrace-inspired-by-creed-silver-mountain-water": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-snowtrace-v2.mp4?v=1784573850",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-snowtrace-v2.mp4?v=1784573850"
  },
  "whisper-dusk-mojave-ghost-inspired": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-whisper-dusk.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-whisper-dusk.mp4?v=1784035834"
  },
  "solar-bloom-inspired-by-tom-ford-soleil-blanc": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-solar-bloom.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-solar-bloom.mp4?v=1784035834"
  },
  "imperial-gold-millesime-imperial-inspired": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-imperial-gold.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-imperial-gold.mp4?v=1784035834"
  },
  "golden-whisper-inspired-by-aventus-for-her": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-golden-whisper.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-golden-whisper.mp4?v=1784035834"
  },
  "veloura-ember": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-veloura-ember.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-veloura-ember.mp4?v=1784035834"
  },
  "ocean-vision": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-ocean-vision.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-ocean-vision.mp4?v=1784035834"
  },
  "rogue-affair-inspired-by-tom-ford-fabulous": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-rogue-affair.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-rogue-affair.mp4?v=1784035834"
  },
  "tavrak-ember-inspired-by-tom-ford-ombre-leather": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-tavrak-ember.mp4?v=1784035834",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-tavrak-ember.mp4?v=1784035834"
  },
  "lunarev-inspired-by-dior-sauvage-elixir": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-lunarev.mp4?v=1784576389",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-lunarev.mp4?v=1784576389"
  },
  "mirelor-inspired-by-armani-stronger-with-you": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-mirelor.mp4?v=1784576389",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-mirelor.mp4?v=1784576389"
  },
  "ovelior-inspired-by-orto-parisi-megamare": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-ovelior.mp4?v=1784576390",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-ovelior.mp4?v=1784576390"
  },
  "celorin-inspired-by-amouage-guidance": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-celorin.mp4?v=1784576389",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-celorin.mp4?v=1784576389"
  },
  "orivale-inspired-by-kilian-apple-brandy-on-the-rocks": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-orivale.mp4?v=1784576390",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-orivale.mp4?v=1784576390"
  },
  "alviren-inspired-by-valentino-born-in-roma": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-alviren.mp4?v=1784576390",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-alviren.mp4?v=1784576390"
  },
  "zenvor-inspired-by-kilian-smoking-hot": {
    sd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-zenvor.mp4?v=1784583476",
    hd: "https://cdn.shopify.com/s/files/1/0759/6428/5178/files/lx-film-zenvor.mp4?v=1784583476"
  }
};
